import { render } from "./EditBuyIn.vue?vue&type=template&id=594cb014&scoped=true"
import script from "./EditBuyIn.vue?vue&type=script&lang=js"
export * from "./EditBuyIn.vue?vue&type=script&lang=js"

import "./EditBuyIn.vue?vue&type=style&index=0&id=594cb014&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594cb014"]])

export default __exports__